import { IDataForRoomsIsRejected } from '../../../actions/bookingCalendar/room/requestDataForRooms'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IDataForRoomsIsRejected,
): IBookingCalendarStore {
  return {
    ...state,
    request: {
      ...state.request,
      rooms: {
        errMessage: action.errMessage,
        isLoading: false,
      },
    },
  }
}
